// Crawl frequency is stored on the backend as crawlerSettings.crawlIntervalDays
// (an integer number of days, 1..365). The UI offers a fixed set of named
// options; these helpers map between the two so the <select> stays bound to the
// stored value and persists a real day-count on change.

export const FREQUENCY_OPTIONS = [
    { label: "Daily", days: 1 },
    { label: "Every 3 days", days: 3 },
    { label: "Weekly", days: 7 },
    { label: "Fortnightly", days: 14 },
    { label: "Monthly", days: 30 },
];

// Pick the option whose day-count is closest to a stored value. Legacy
// workspaces may hold an interval that doesn't match an option exactly (e.g. 5):
// we show the nearest rather than inventing an option, and a save then snaps it
// to that option's value. On an exact tie (5 is equidistant from 3 and 7) the
// larger option wins — `<=` lets a later, equally-close option replace an
// earlier one — so 5 rounds up to Weekly (7) rather than down to 3.
export function nearestFrequencyDays(storedDays) {
    if (storedDays == null) return FREQUENCY_OPTIONS[0].days;
    let nearest = FREQUENCY_OPTIONS[0];
    for (const option of FREQUENCY_OPTIONS) {
        if (Math.abs(option.days - storedDays) <= Math.abs(nearest.days - storedDays)) {
            nearest = option;
        }
    }
    return nearest.days;
}
